import { Producers } from '../../../constants/producers';
import { TicketType as TicketTypeValues } from '../../../constants/tickets';
import { Event } from '../../../types/event';
import { Membership } from '../../../types/membership';
import { Ticket } from '../../../types/ticket';
import { useI18nContext } from '../i18n.context';
import { ValidationStrategy } from './validationStrategy';
const { COMPANION } = TicketTypeValues;
export class BotafogoStrategy extends ValidationStrategy {
  /**
   * Checks if the given event is a Botafogo event based on its producer ID.
   *
   * @param {Event | null} event - The event to check.
   * @returns {boolean} Returns `true` if the event is a Botafogo event, otherwise `false`.
   */
  protected _isBotafogoEvent(event: Event | null): boolean {
    const botafogoProducerIds = Producers.Botafogo;
    return botafogoProducerIds.includes(event?.producerId || 0);
  }
}

export class MembershipBotafogoStrategy extends BotafogoStrategy {
  shouldApply(membershipApplied: Membership | null, event: Event | null) {
    return !!membershipApplied && this._isBotafogoEvent(event);
  }

  validate(membershipApplied: Membership | null, cart: Ticket[], event: Event | null,
    tickets: Ticket[], groupId: number, ticketId: number, totalTickets: number) {
    const { translate } = useI18nContext();
    const baseValidation = super.validate(membershipApplied, cart, event, tickets, groupId, ticketId, totalTickets);
    if (baseValidation.disableAddToCart) return baseValidation;

    //The cart contains the max number of companions
    const cartContainsMaxCompanion = cart
      .map(group =>
        group.type
          .filter(type => Number(type.category.id) === COMPANION)
          .reduce((sum, type) => sum + type.quantityInCart, 0)
      )
      .reduce((total, companionQuantity) => total + companionQuantity, 0) >= 2;

    if (cartContainsMaxCompanion) {
      const isTryingToAddRelevantCategory = tickets.some(group =>
        group.id === groupId &&
        group.type.some(type =>
          Number(type.category.id) === COMPANION && type.id === ticketId
        )
      );
      if (isTryingToAddRelevantCategory) {
        return {
          disableAddToCart : true,
          errorMessage : translate(['INFORMATION', 'LIMIT_REACHED']),
        };
      }
    }
    const containsMoreThanMax = event && totalTickets >= event.attributes.cpfTicketsLimit.value;
    return { disableAddToCart : !!containsMoreThanMax, errorMessage : null };
  }
}

